import React from "react";
import "./RecentEvents.css";

// import gi1 from "../../Assets/SportsDay/SP1.JPG";
// import gi2 from "../../Assets/SportsDay/SP2.JPG";
// import gi3 from "../../Assets/SportsDay/SP3.JPG";
// import video from "../../Assets/SportsDay/Sports Day 2026.mp4";

const RecentEvents = ({ data, gallery }) => {
  const classroomGallery = gallery?.find(
    (item) => item.title === data?.recent_event?.title,
  );
  const latestImages = classroomGallery?.images?.slice(-3).reverse() || [];
  const latestVideo = classroomGallery?.images?.find((item) =>
    item.mime?.startsWith("video"),
  );

  return (
    <section className="recent-events">
      <p className="founder-subtitle">{data?.reeventSubtitle}</p>

      <h2 className="founder-title">
        {data?.recent_event?.title?.split(" ").slice(0, -1).join(" ")}
        <span>
          {" "}
          {data?.recent_event?.title?.split(" ").slice(-1).join(" ")}
        </span>
      </h2>
      <p className="event-date">{data?.reeventDate}</p>
      <p className="founder-desc">{data?.reeventDescription}</p>

      <div className="event-content">
        {/* Photo Gallery */}
        <div className="event-gallery">
          {latestImages.map((img, index) => (
            <img key={index} src={img.url} alt={`gallery-${index}`} />
          ))}
        </div>

        {/* Latest Video */}

        {latestVideo && (
          <div className="event-video">
            <video width="100%" controls>
              <source src={latestVideo.url} type={latestVideo.mime} />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
      </div>
    </section>
  );
};

export default RecentEvents;
